/** @jsx jsx */
import { Box, Grid, jsx } from 'theme-ui'

const SideBySideGrid = ({
  first,
  second,
  padSecond = true,
  swapOrder = false,
}) => {
  return (
    <Grid
      columns={[null, 2]}
      gap={[null, 3]}
      sx={{
        alignItems: [null, 'center'],
        gridTemplateAreas: [null, "'first second'"],
      }}
    >
      <Box
        sx={{
          gridArea: [null, !swapOrder ? 'first' : 'second'],
          gridRow: [null, '1'],
        }}
      >
        {first}
      </Box>
      <Box
        mt={[4, 0]}
        px={padSecond && 1}
        sx={{
          gridArea: [null, !swapOrder ? 'second' : 'first'],
          gridRow: [null, '1'],
        }}
      >
        {second}
      </Box>
    </Grid>
  )
}

export default SideBySideGrid
